<template>
  <div class="bodys" v-if="body_show">
    <div class="course_qu">
      <h2>课程联报</h2>
      <ul>
        <li v-for="(item,index) in data.bigCourse" :key="index">
          <h1>
            <router-link :to="'/course_details?bid='+item.id">
            <img :src="item.promotionimg" alt="" />
            <div class="course_title">{{item.name}}</div>
            <span></span>
            </router-link>
          </h1>
          <h3>课程原价：¥ {{item.originalprice}}</h3>
          <h3>课程时长：{{item.cycle}} 周</h3>
          <!-- 每个课程的开课时间 -->
          <div class="task-select-group">
            <div class="select_left">开课时间：</div>
            <div class="select-group" @click="selectPicker(item.courseList,index)">
              <input readonly type="text"  v-model="item.course_begintime" />
              <img src="@a/bottom.png" alt="">
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="course_price">
      <h2>课程总价：¥ {{total_price}}</h2>
      <h2>课程优惠：<span>-¥ {{data.favorable}}</span></h2>
      <h1>限时特价：¥ {{(total_price-data.favorable).toFixed(2)}}</h1>
      <!-- <p>注：当您发起退费申请时，单课程退费为“所退费用=联报课程价格-所剩课程原价”</p> -->
    </div>
    <div class="course_pay" @click="signHandle" v-if="bm_show">您已报名</div>
    <div class="course_pay" @click="signHandle" v-else>¥ {{(total_price-data.favorable).toFixed(2)}} 立即报名</div>
    <!-- 选择期次 -->
    <van-popup v-model="score_picker" position="bottom">
      <van-picker show-toolbar :columns="picker_arr" @cancel="cancel" @confirm="confirm" />
    </van-popup>
    <!-- 其中一门课程已经购买 -->
    <van-popup class="follow" v-model="follow_show">
      <p>你好，你已报名“<span v-for="(item,index) in data.buyList" :key="index">{{item.name}}<span v-if="index+1<data.noBuyList.length">、</span></span>”可直接报名“<span v-for="(item,index) in data.noBuyList" :key="index">{{item.name}}<span v-if="index+1<data.noBuyList.length">、</span></span>”</p>
      <div class="href">
        <router-link v-for="(item,index) in data.noBuyList" :key="index" :to="'/course_details?bid='+item.id" v-if="data.noBuyList.length==1" style="width:100%">去报名</router-link>
        <router-link v-for="(item,index) in data.noBuyList" :key="index" :to="'/course_details?bid='+item.id" v-if="data.noBuyList.length>1">{{item.name}}</router-link>
      </div>
    </van-popup>
    <!-- 验证手机号和付款 -->
    <public-mobile ref="handle" :orderObj="orderObj"></public-mobile>
  </div>
</template>
<script>
import {
  listOffers,
  buyCourseOffers
} from "@/api/course"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        type_obj: {},
        data: {},
        score_picker: false,
        select_obj: {},
        total_price: 0,
        follow_show: false,
        orderObj: {},
        bm_show: false
      };
    },
    methods: {
      /*
       *@param: idx 下标
       *@return: 
       *@Description: 改变课程期次时间触发
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2020-05-08 10:45:06
      */
      courseChange(idx){
        console.log('我进来了',this.data.bigCourse[idx].course_begintime);
        let endTime = '';
        for (let arg of this.data.bigCourse[idx].courseList) {
          if (arg.course_begintime == this.data.bigCourse[idx].course_begintime) {
            endTime = arg.course_endtime;
          }
        };
        // 第一个课程时间改变
        for(let i=(idx+1);i<this.data.bigCourse.length;i++){
          if(this.data.bigCourse[i].courseList.length>0){
            // 循环课程期次
            for(let p=0;p<this.data.bigCourse[i].courseList.length;p++){
              if(this.tab(this.data.bigCourse[i].courseList[p].course_begintime,endTime)){
                this.data.bigCourse[i].course_begintime = this.data.bigCourse[i].courseList[p].course_begintime;
                this.data.bigCourse[i].cid = this.data.bigCourse[i].courseList[p].id;
                this.data.bigCourse[i].cycle = this.data.bigCourse[i].courseList[p].cycle;
                this.data.bigCourse[i].originalprice = this.data.bigCourse[i].courseList[p].originalprice;
                break;
              }
            }
          }
          
        }
      },
      // 比较日期大小
      tab(date1,date2){
        return new Date(date1).getTime() > new Date(date2).getTime()
      },
      // 立即报名
      signHandle() {
        if (this.data.buy) {
          if(this.data.noBuyList.length>0) {
            this.follow_show = true;
          }else {
            this.$router.push('/my_course')
          }

        } else {
          this.$refs.handle.pay_quote();
        }
      },
      selectPicker(courseList, index) {
        let arr = [];
        for (let arg of courseList) {
          arr.push(arg.course_begintime)
        }
        this.picker_arr = arr;
        this.select_obj['index'] = index;
        this.score_picker = true;
      },
      // 选择窗取消函数
      cancel(data) {
        this.score_picker = false;
      },
      // 选择窗确认函数
      confirm(value) {
        let index = this.select_obj.index;
        this.data.bigCourse[index].course_begintime = value;
        for (let arg of this.data.bigCourse[index].courseList) {
          if (arg.course_begintime == value) {
            this.data.bigCourse[index].cid = arg.id;
            this.data.bigCourse[index].cycle = arg.cycle;
            this.data.bigCourse[index].originalprice = arg.originalprice;
          }
        };
        this.assign_value();
        this.$forceUpdate();
        this.score_picker = false;
        // 判断第二门课程开课时间是否小于第一门结课时间
        this.courseChange(index);
      },
      assign_value() {
        let id_arr = [];
        let price_arr = 0;
        for (let args of this.data.bigCourse) {
          id_arr.push(args.cid);
          price_arr += Math.floor(args.originalprice * 100) / 100;
        }
        this.total_price = price_arr.toFixed(2);
        this.cid = id_arr.join();
        this.orderObj = {
          cid: this.cid,
          shareuser: this.shareuser?this.shareuser:'',
          joint: this.joint
        }
      },
      pullData() {
        this.joint_id = this.$route.query.joint_id;
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        listOffers({
          joint: this.joint_id
        }).then(data => {
          if (data.bigCourse) {
            this.body_show = true;
            this.data = data;
            if(this.data.buy&&this.data.noBuyList.length==0){
              this.bm_show = true
            }
            this.shareuser = this.$route.query.shareuser;
            this.joint = this.$route.query.joint_id;
            for (let arg of data.bigCourse) {
              arg.course_begintime = arg.courseList[0].course_begintime;
              arg.cid = arg.courseList[0].id;
              arg.cycle = arg.courseList[0].cycle;
              arg.originalprice = arg.courseList[0].originalprice;
            };
            this.assign_value();
            // 分享
            this.type_obj = {
              nickname: data.user.nickname,
              shareuser: data.user.uid
            };
            shareCon("course_quote", this, this.type_obj);
            this.$toast.clear();
          } else {
            this.$toast.loading({
              mask: true,
              message: data.msg
            });
          }
        });
      }
    },
    created() {
      this.pullData();
    }
};
</script>
<style lang="scss" scoped>
.bodys {
  padding-bottom: 150px;
}

.course_pay {
  width: 750px;
  height: 98px;
  background: rgba(235, 80, 50, 1);
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -375px;
  line-height: 98px;
  text-align: center;
  font-size: 34px;
  color: #fff;
}

.radio_group .van-radio__icon .van-icon {
  width: 41px;
  height: 41px;
  line-height: 41px;
  background: url(../../../assets/radio_.png) no-repeat top center;
  background-size: cover;
  border-color: transparent;
  background-color: transparent;
}

.radio_group .van-radio__icon .van-icon:before {
  content: '';
}

.radio_group .van-radio__icon.van-radio__icon--checked .van-icon.van-icon-success {
  background-image: url(../../../assets/radio_active.png);
}

.radio_group .van-radio__label {
  line-height: 42px;
  width: 618px;
  margin-left: 30px;
  font-size: 32px;
}

.course_qu {
  padding: 30px;
  h2 {
    font-size: 36px;
    color: #333;
    font-weight: bold;
  }
  ul li {
    width: 100%;
    margin-top: 30px;
    background: #fff;
    padding-bottom: 30px;
    h1 {
      width: 100%;
      background: rgba(235, 80, 50, 1);
      border-radius: 4px 4px 0 0;
      position: relative;
      padding: 15px;
      margin-bottom: 10px;
      img {
        width: 176px;
        height: 110px;
        border: 5px solid #fff;
      }
      .course_title {
        width: 400px;
        margin-left: 20px;
        line-height: 42px;
        color: #fff;
        font-size: 26px;
        display: inline-block;
        vertical-align: top
      }
      span {
        background: url(../../../assets/uxb.png) no-repeat top center;
        background-size: cover;
        width: 16px;
        height: 25px;
        position: absolute;
        top: 20px;
        right: 20px;
        color: #fff;
        font-size: 32px;
      }
    }
    h3 {
      color: #333;
      font-size: 26px;
      padding: 6px 16px;
    }
  }
}

// select
.task-select-group {
  padding: 6px 16px;
  .select_left {
    color: #333;
    font-size: 26px;
    display: inline-block;
  }
  .select-group {
    position: relative;
    text-align: left;
    width: 524px;
    display: inline-block;
    border: 2px solid rgba(204, 204, 204, 1);
    border-radius: 8px;
    input {
      line-height: 48px;
      border-radius: 8px;
      border: none;
      padding: 0 24px;
      // width: 100%;
    }
    img {
      position: absolute;
      right: 20px;
      top: 16px;
      width: 27px;
      height: 16px;
    }
  }
  .flex-select-group {
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    align-content: space-around;
    .select-group {
      margin-right: 14px;
      width: 220px;
      input {
        width: 100%;
        font-size: 26px;
        padding-left: 20px;
        box-sizing: border-box;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    .select-group.on {
      margin-right: 0;
      width: 100%;
      margin-bottom: 16px;
      input {
        width: 100%;
      }
    }
  }
}

.course_price {
  padding: 0 30px;
  margin-top: 10px;
  h2 {
    font-size: 28px;
    color: #333;
    span {
      color: #F47F17
    }
  }
  h1 {
    margin-top: 8px;
    font-size: 32px;
    color: #333;
    font-weight: bold;
  }
  p {
    text-align: justify;
    font-size: 26px;
    color: #666;
    line-height: 36px;
    margin-top: 10px;
  }
}

.follow {
  width: 480px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  p {
    padding: 0 20px;
    line-height: 40px;
    color: #333;
    font-size: 26px;
    text-align: justify;
    margin-top: 36px;
  }
  .href {
    margin-top: 30px;
    border-top: 1px solid #ccc;
    a {
      width: 100%;
      display: inline-block;
      border-right: 1px solid #ccc;
      line-height: 92px;
      width: 50%;
      text-align: center;
      font-size: 32px;
      color: #EB5032;
      white-space: nowrap;
      /*规定段落中的文本不进行换行*/
      overflow: hidden;
      /*内容会被修剪，并且其余内容是不可见的。*/
      text-overflow: ellipsis;
      /*显示省略号来代表被修剪的文本*/
    }
    a:last-child {
      border-right: none;
    }
  }
}
</style>
